
enum ScenarioActionTypes {
    Wait = 1,
    Face = 2,
    FaceLocation = 4,
    FaceTarget = 5,
    Look = 7,
    LookTarget = 10,
    PassTarget = 11,
    LongPassTarget = 13,
    ShootDirection = 14,
    Route = 16,
    GetBall = 17,
    Score = 18,
    InterceptBall = 19,
    Signal = 20,
    ThroughPassTarget = 21,
    BlockBall = 22,
    KickToLocation = 23,
    PickUpBall = 24,
}

export default ScenarioActionTypes;